export default class PostAnonymousAuctionController {
    constructor() {
        const element = document.querySelector(".js-auction-anonymous");

        if (element) {
            import(
                /* webpackChunkName: "PostAnonymousAuctionController" */ "../classes/PostAnonymousAuction"
            ).then(res => {
                const PostAnonymousAuction = res.default;
                this.createInstance(PostAnonymousAuction, element);
            });
        }
    }

    createInstance(PostAnonymousAuction, element) {
        return new PostAnonymousAuction(element);
    }
}
